<template>
  <span class="change">
    {{type}}
  </span>
</template>

<script>

export default {
  name: 'ChangeBus',
  props: {
    forward: {
      type: Number,
      required: true,
    },
    backward: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getChange(cnt) {
      if (cnt === 1) {
        return this.$tc('changeBus.change', 0);
      }

      if (cnt > 1 && cnt < 5) {
        return this.$tc('changeBus.change', 1);
      }

      return this.$tc('changeBus.change', 2);
    },
  },
  computed: {
    type() {
      if (!this.backward && this.forward === 1) {
        return this.$t('changeBus.nochange');
      }

      if (!this.backward && this.forward > 1) {
        return `${this.forward - 1} ${this.getChange(this.forward - 1)}`;
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
#app, #auth {
  .change {
    font-size: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/ChangeBus.vue